"use client";

import { c as _c } from "react/compiler-runtime";
import { CicStatement } from "@/entities/IProfile";
import { useEffect, useState } from "react";
import PencilIcon from "@/components/utils/icons/PencilIcon";
import UserPageHeaderAboutStatement from "./UserPageHeaderAboutStatement";
import UserPageHeaderAboutEdit from "./UserPageHeaderAboutEdit";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
enum AboutStatementView {
  STATEMENT = "STATEMENT",
  EDIT = "EDIT",
}
export default function UserPageHeaderAbout(t0) {
  const $ = _c(22);
  const {
    profile,
    statement,
    canEdit
  } = t0;
  const [view, setView] = useState(AboutStatementView.STATEMENT);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setView(AboutStatementView.STATEMENT);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== canEdit || $[2] !== profile || $[3] !== statement) {
    t2 = [profile, statement, canEdit];
    $[1] = canEdit;
    $[2] = profile;
    $[3] = statement;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== view) {
    t3 = () => {
      if (view === AboutStatementView.STATEMENT) {
        setView(AboutStatementView.EDIT);
      } else {
        setView(AboutStatementView.STATEMENT);
      }
    };
    $[5] = view;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const toggleView = t3;
  let t4;
  if ($[7] !== toggleView || $[8] !== view) {
    t4 = () => {
      if (view === AboutStatementView.STATEMENT) {
        toggleView();
      }
    };
    $[7] = toggleView;
    $[8] = view;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const onEditClick = t4;
  let t5;
  if ($[10] !== canEdit || $[11] !== onEditClick || $[12] !== statement || $[13] !== view) {
    t5 = view === AboutStatementView.STATEMENT && <div className="tw-max-w-full lg:tw-max-w-prose tw-mt-4"><button onClick={onEditClick} disabled={!canEdit} type="button" aria-label={statement ? "Edit About statement" : "Add About statement"} className="tw-flex tw-items-center tw-gap-x-2 tw-text-iron-500 hover:tw-text-iron-200 tw-text-left tw-group tw-bg-transparent tw-border-none tw-m-0 tw-p-0 tw-relative tw-transition tw-duration-300 tw-ease-out"><UserPageHeaderAboutStatement statement={statement} />{canEdit && <div className={`${statement ? "group-hover:tw-block tw-hidden" : "tw-block"}  tw-text-iron-400`}><PencilIcon /></div>}</button></div>;
    $[10] = canEdit;
    $[11] = onEditClick;
    $[12] = statement;
    $[13] = view;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== profile || $[16] !== statement || $[17] !== view) {
    t6 = view === AboutStatementView.EDIT && <div className="tw-max-w-full tw-mt-4"><UserPageHeaderAboutEdit profile={profile} statement={statement} onClose={() => setView(AboutStatementView.STATEMENT)} /></div>;
    $[15] = profile;
    $[16] = statement;
    $[17] = view;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t5 || $[20] !== t6) {
    t7 = <div>{t5}{t6}</div>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}